<div class="document-card-container">
  <div class="document">
    <div class="header px-3 py-2">
      <div class="header-title">
        <mat-icon class="header-icon">
          <img src="{{ docSvgLoc }}" alt="docImage" style="height: 30px; width: 30px" />
        </mat-icon>
        <span class="head extra-space">{{ docTypeText }}</span>
      </div>
      <div class="three-dots-container" [matMenuTriggerFor]="beforeMenu">
        <img src="assets/icons/3dots.png" class="threedots" />
        <mat-menu class="matmenu" #beforeMenu="matMenu" xPosition="before">
          <button mat-menu-item class="first" (click)="open(content10)">
            <span class="connect">View</span>
          </button>
          <button mat-menu-item class="first" (click)="downloadFile()">
            <span class="connect">Download</span>
          </button>
          <button mat-menu-item (click)="openCardDialog('EDIT')">
            <span class="bold">Edit</span>
          </button>
          <button mat-menu-item (click)="openDeleteConfirmationDialog(documentDetails)">
            <span class="bold">Delete</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="doc-body">
      <table class="table document-table">
        <thead>
          <tr>
            <th class="card-header" [ngClass]="{'left-padding':getFormattedType(documentDetails.documentType) === 'Address Proof'}" *ngIf="documentDetails?.documentProofType">Document Proof</th>
            <th class="card-header" [ngClass]="{'left-padding':getFormattedType(documentDetails.documentType) !== 'Address Proof'}">{{ getFormattedType(documentDetails.documentType) }} No.</th>
            <th class="card-header" *ngIf="documentDetails.issue_at">Issue Date</th>
            <th class="card-header" *ngIf="documentDetails.name_on_document">Name on Document</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngIf="documentDetails?.documentProofType" class="card-details" [ngClass]="{'left-padding':getFormattedType(documentDetails.documentType) === 'Address Proof'}" >{{ documentDetails.documentProofType }}
            </td>
            <td class="card-details" [ngClass]="{'left-padding':getFormattedType(documentDetails.documentType) !== 'Address Proof'}">{{ documentDetails.document_number }}</td>
            <td *ngIf="documentDetails.issue_at" class="card-details">{{ documentDetails.issue_at | date:'dd-MM-yyyy' }}
            </td>
            <td *ngIf="documentDetails.name_on_document" class="card-details">{{ documentDetails.name_on_document }}
            </td>
          </tr>
        </tbody>
      </table>
      <ng-container *ngIf="documentDetails?.cloud_storage_path">
        <ng-template #content10 let-modal>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            <div *ngIf="documentDetails?.file_extension == 'pdf'">
              <pdf-viewer [src]="document_download_url" [rotation]="0" [fit-to-page]="false" [original-size]="false"
                [show-all]="true" class="pdf-attachment"></pdf-viewer>
            </div>
            <div *ngIf="
                documentDetails?.file_extension === 'png' ||
                documentDetails?.file_extension === 'jpeg' || 
                documentDetails?.file_extension === 'jpg' 
              ">
              <img class="preview-img" [src]="document_view_url" />
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>